import { Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar:MatSnackBar) { }

  openSnackBar(message: string,duration: any = 3000, position:any = 'bottom') {
    let config = new MatSnackBarConfig();
    config.duration = duration;
    config.panelClass = ['error-snackbar'];
    config.verticalPosition = position;
    this.snackBar.open(message, "Okay", config);
  }
}
